import { supabase } from "../db"

const profileTable = 'profiles';

export const loginUser = async (email, password) => {
  const { data, error } = await supabase.auth.signInWithPassword({
    email,
    password
  });
  if (error) throw error;
  return data;
};

export const getProFile = async () => {
  const {
    data: { user },
    error: userError
  } = await supabase.auth.getUser();

  if (!user || userError) throw userError || new Error('User not found');

  const userId = user.id;
  const { data, error } = await supabase
    .from(profileTable)
    .select('*')
    .eq('id', userId)
    .maybeSingle();

  if (error) throw error;
  return data;
};

export const getUserProfile = async (uuid) => {
  const { data, error } = await supabase
    .from(profileTable)
    .select('*')
    .eq('id', uuid)
    .maybeSingle();

  if (error) throw error;
  return data;
};

export const logoutUser = async () => {
  const { error } = await supabase.auth.signOut();
  if (error) throw error;
};

export const signUpUser = async (formData) => {
  const {
    email,
    password,
    firstName,
    lastName,
    phone,
    userType,
    experience,
    address,
    city,
    state,
    zipCode,
    agreeTerms,
    newsletter,
  } = formData;

  const { data, error } = await supabase.auth.signUp({
    email,
    password,
    options: {
      data: {
        first_name: firstName,
        last_name: lastName,
      },
      emailRedirectTo: `${window.location.origin}/auth/callback`,
    }
  });

  if (error) throw error;

  if (data.user) {
    const { data: profileResult, error: functionError } = await supabase
      .rpc('update_profile_on_signup', {
        user_id: data.user.id,
        user_email: email,
        user_first_name: firstName,
        user_last_name: lastName,
        user_phone: phone,
        user_user_type: userType,
        user_experience: experience ? Number(experience) : null,
        user_address: address,
        user_city: city,
        user_state: state,
        user_zip_code: zipCode,
        user_agree_terms: agreeTerms,
        user_newsletter: newsletter
      });

    if (functionError) {
      return {
        authData: data,
        profileData: {
          id: data.user.id,
          email,
          role: 'user',
          first_name: firstName,
          last_name: lastName,
          phone,
          user_type: userType,
          experience: experience ? Number(experience) : null,
          address,
          city,
          state,
          zip_code: zipCode,
          agree_terms: agreeTerms,
          newsletter,
        },
      };
    }

    return {
      authData: data,
      profileData: profileResult || {
        id: data.user.id,
        email,
        role: 'user',
        first_name: firstName,
        last_name: lastName,
        phone,
        user_type: userType,
        experience: experience ? Number(experience) : null,
        address,
        city,
        state,
        zip_code: zipCode,
        agree_terms: agreeTerms,
        newsletter,
      },
    };
  }

  return { authData: data, profileData: null };
};